import { useMutationUpgradeWorkspace } from '@/pages/workgroup/hook';
import { WorkspaceT } from '@/pages/workgroup/type';
import toast from 'react-hot-toast';
import { getErrorMessage } from '@/utils/utils';

export type UpgradeTiming = 'now' | 'schedule';

export type UpgradeConfirmPayload = { version: string; timing: UpgradeTiming };

export function useUpgradeVersionHandler() {
  const { mutateAsync: upgradeWorkspace, isLoading: upgrading } = useMutationUpgradeWorkspace();

  const handleUpgradeConfirm = async (
    workspace: WorkspaceT,
    { version, timing }: UpgradeConfirmPayload,
    options?: { onScheduleSuccess?: () => void }
  ) => {
    if (timing === 'now') {
      const promise = upgradeWorkspace({
        workgroup_id: workspace.workgroup_id,
        workspace_id: workspace.workspace_id,
        version,
        scheduled: false,
      });
      toast.promise(promise, {
        loading: 'Starting upgrade...',
        success: 'Workspace upgrade started successfully!',
        error: (err) => `Failed to start upgrade: ${getErrorMessage(err as Error)}`,
      });
      return;
    }

    const promise = upgradeWorkspace({
      workgroup_id: workspace.workgroup_id,
      workspace_id: workspace.workspace_id,
      version,
      scheduled: true,
    });

    toast
      .promise(promise, {
        loading: 'Saving upgrade configuration...',
        success: 'Upgrade scheduled during maintenance window.',
        error: (err) => `Failed to schedule upgrade: ${getErrorMessage(err as Error)}`,
      })
      .then(() => {
        options?.onScheduleSuccess?.();
      })
      .catch(() => {
        // error toast already handled above
      });
  };

  return { handleUpgradeConfirm, isLoading: upgrading };
}
